import { useCallback } from "react";
import type { VehicleZoneViolationIncident } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchVehicleZoneViolationIncident = (
    id?: string | null,
): UseFetchActionReturn<VehicleZoneViolationIncident | undefined> => {
    const fetchVehicleZoneViolationIncident: () => Promise<
        VehicleZoneViolationIncident | undefined
    > = useCallback(() => {
        if (id) {
            return store.vehicleZoneViolationEventsApi.vehicleZoneViolationEventsReadVehicleZoneViolationIncident(
                { id },
            );
        } else {
            return Promise.resolve(undefined);
        }
    }, [id]);
    return useFetchAction(fetchVehicleZoneViolationIncident);
};
